<template>
    <div :class="[ 'schedule-table', { 'schedule-table--margin': !settings.removeMargin } ]"
    :style="`--max-height: ${settings.maxHeight || '300px'}`">
        <modal
            v-if="openAddModal"
            :form="{
                class: 'schedule-table__modal'
            }"
            :customSettings="{
                class: 'schedule-table__modal__content',
                position: 'center',
                color: 'green',
                button: {
                    label: 'confirm',
                    type: 'submit',
                    action: () => {
                        closeAddSchedule(),
                        addToSchedule()
                    }
                }
            }"
            @close="closeAddSchedule()"
            :key="openAddModal"
        >
            <template #modal__header >
                <h2 class="cblock__modal__header">{{ $t('global.addSchedule') }}</h2>
            </template>
            <template #modal__body__confirm >
                <base-field
                        class="schedule-table__day"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.day') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'weekday',
                                name: 'weekday',
                                type: 'text',
                                value: '',
                                targetClass: 'field__input--default typography--default color--default',
                                isRequired: $route.meta.isAdd,
                                browserAutocomplete: 'off',
                                dynamicData: {
                                    data: daysDrop
                                }
                            },
                            allowFilling: true
                        }"
                />
                <div class="display--flex schedule-table__add-inputs">
                    <base-field
                        class="campaign__body__edate"
                        v-model="startValue"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.startsAt') },
                            input: {
                                component: 'InputTimeSelector',
                                name: 'startsAt',
                                id: 'startsAt',
                                targetClass: 'field__input--default typography--default color--default',
                                value: startValue,
                                browserAutocomplete: 'off'
                            },
                            allowFilling: true
                        }"
                    />
                    <base-field
                        class="campaign__body__edate"
                        v-model="endValue"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.endsAt') },
                            input: {
                                component: 'InputTimeSelector',
                                name: 'endsAt',
                                id: 'endsAt',
                                targetClass: 'field__input--default typography--default color--default',
                                value: endValue,
                                browserAutocomplete: 'off'
                            },
                            allowFilling: true
                        }"
                    />
                </div>
            </template>
            <template #modal__info >
                <base-button
                    class="modal__content__button--negative background--transparent border--grey"
                    @click.prevent="closeAddSchedule(); contactValue = null; blockBarAndResetPayload()"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
        <transition name="fade" mode="out-in">
        <div v-if="list.length" class="table--with-results" aria-label="table">
            <div class="schedule-table__body scroll" role="rowgroup"
                v-for="( row, index ) in schedule"
                :key="index"
                :class="[
                    'schedule-table__body__row display--flex',
                    { 'schedule-table__body__row--color': row.id % 2 === 0 && row.id !== 0 }
                ]"
            >
                <span class="schedule-table__body__row__weekday">
                    {{ row.weekday }}
                </span>
                <div class="schedule-table__body__row__time--container display--flex">
                    <span
                        v-for="( time, indexFieldY ) in row.schedules"
                        :key="indexFieldY"
                        class="schedule-table__body__row__time pointer"
                        @click="
                            openEditModal = true;
                            startValue = time.startsAt;
                            endValue = time.endsAt;
                            timeId = time.id;
                            interruptMessageFunction();"
                    >
                        {{ time.startsAt }} - {{ time.endsAt }}
                    </span>
                </div>
            </div>
            <modal
                v-if="openEditModal"
                :form="{
                    class: 'schedule-table__modal'
                }"
                :customSettings="{
                    class: 'schedule-table__modal__content',
                    position: 'center',
                    color: 'green',
                    button: {
                        label: 'confirm',
                        type: 'submit',
                        action: () => {
                            openEditModal = false,
                            addToPayload( timeId )
                        }
                    }
                }"
                @close="openEditModal = false"
                :key="openEditModal"
            >
                <template #modal__header >
                    <h2 class="cblock__modal__header">{{ $t('global.editSchedule') }}</h2>
                </template>
                <template #modal__body__confirm >
                    <div class="display--flex">
                        <base-field
                            class="campaign__body__edate"
                            v-model="startValue"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.startsAt') },
                                input: {
                                    component: 'InputTimeSelector',
                                    name: 'startsAt',
                                    id: 'startsAt',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: startValue,
                                    browserAutocomplete: 'off',
                                },
                                isEdition,
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="campaign__body__edate"
                            v-model="endValue"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.endsAt') },
                                input: {
                                    component: 'InputTimeSelector',
                                    name: 'endsAt',
                                    id: 'endsAt',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: endValue,
                                    browserAutocomplete: 'off',
                                },
                                isEdition,
                                allowFilling: true
                            }"
                        />
                    </div>
                </template>
                <template #modal__info >
                    <base-button
                        type="submit"
                        class="background--transparent color--red border--red"
                        @click="openEditModal = false; removeSchedule( timeId )"
                        v-html="$t('global.remove')"
                    />
                </template>
            </modal>

        </div>
        <div v-else class="schedule-table--without-results">{{ $t('global.noRecordsFound', { type: settings.warning} ) }}</div>
        </transition>
    </div>
</template>

<script>
// hooks
import { singleStructure } from '@/hooks/use-data';
// packages
import { reactive, toRefs, watch } from '@vue/composition-api';
// plugins
import i18n from '@/plugins/i18n';
// configs
import { weekDays } from '@/configs/const';
// hooks
import { blockActionBar } from '@/components/bundles/functional/Modal';

// store
import { useActions, mapState } from '@/hooks/use-store';

export default {
    components: {
        ...singleStructure.components,
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        ...singleStructure.props,
        headers: Array,
        list: Array,
        model: String,
        settings: Object,
        addSchedule: Boolean,
        startsAtProp: String,
        endsAtProp: String
    },
    setup ( props, { emit }) {
        const bools = reactive({
            openEditModal: false,
            openAddModal: props.addSchedule,
            newList: false
        });

        const interruptMessageFunction = () => {
            actions( 'manageResponse', { interrupt: true });
        };
        watch( () => props.addSchedule,
            bool => {
                bools.openAddModal = bool;
                // predefinir valores da input do adicionar horario (00:00 - 23:59)
                if ( bools.openAddModal ) {
                    scheduleInfo.startValue = props.startsAtProp.substring( 0, 5 );
                    scheduleInfo.endValue = props.endsAtProp.substring( 0, 5 );
                    actions( 'registerField', { name: 'startsAt', value: props.startsAtProp });
                    actions( 'registerField', { name: 'endsAt', value: props.endsAtProp });
                }
            });
        const closeAddSchedule = () => {
            bools.openAddModal = false;
            emit( 'close-add-modal' );
        };

        const blockBarAndResetPayload = () => {
            blockActionBar( false );
        };

        const scheduleInfo = reactive({
            timeId: null,
            startValue: null,
            endValue: null,
            daysDrop: Object.keys( weekDays ).map( key => ({ value: key, label: weekDays[key] }) )
        });

        const state = reactive({
            schedule: {
                'Segunda feira': {
                    id: 1,
                    weekday: i18n.t( 'global.Mon' ),
                    schedules: []
                },
                'Terça feira': {
                    id: 2,
                    weekday: i18n.t( 'global.Tue' ),
                    schedules: []
                },
                'Quarta feira': {
                    id: 3,
                    weekday: i18n.t( 'global.Wed' ),
                    schedules: []
                },
                'Quinta feira': {
                    id: 4,
                    weekday: i18n.t( 'global.Thu' ),
                    schedules: []
                },
                'Sexta feira': {
                    id: 5,
                    weekday: i18n.t( 'global.Fri' ),
                    schedules: []
                },
                Sábado: {
                    id: 6,
                    weekday: i18n.t( 'global.Sat' ),
                    schedules: []
                },
                Domingo: {
                    id: 0,
                    weekday: i18n.t( 'global.Sun' ),
                    schedules: []
                }
            }
        });

        props.headers.forEach( day => {
            props.list.forEach( element => {
                if ( element.weekday === day ) {
                    state.schedule[element.weekday].schedules.push({
                        id: element.id,
                        startsAt: `${element.startsAt.substring( 0, 5 )}`,
                        endsAt: `${element.endsAt.substring( 0, 5 )}`
                    });
                }
            });
        });

        let schedules = JSON.parse( JSON.stringify( props.list ) );

        // store
        const { actions } = useActions();
        const payload = mapState({ module: 'storePayload', key: 'payload' });
        const response = mapState({ module: 'storePayload', key: 'response' });

        // watcher para atualizar tabela após submissão dos dados
        watch( () => response.value,
            data => {
                if ( data.has && data.content ) {
                    props.headers.forEach( day => {
                        state.schedule[day].schedules = [];
                        data.content.schedules.forEach( element => {
                            if ( element.weekday === day ) {
                                state.schedule[element.weekday].schedules.push({
                                    id: element.id,
                                    startsAt: `${element.startsAt.substring( 0, 5 )}`,
                                    endsAt: `${element.endsAt.substring( 0, 5 )}`
                                });
                            }
                        });
                    });
                    schedules = JSON.parse( JSON.stringify( data.content.schedules ) );
                    scheduleInfo.startValue = null;
                    scheduleInfo.endValue = null;
                }
            },
            { deep: true });

        // remove schedule
        const removeSchedule = removeId => {
            schedules = [ {
                id: removeId,
                operation: 'delete'
            } ];
            actions( 'registerField', { name: 'schedules', value: schedules });
        };

        // adicionar ao payload array de horarios atualizado após edição
        const addToPayload = id => {
            if ( payload.value.endsAt || payload.value.startsAt ) {
                // atualização do array
                schedules.forEach( element => {
                    element.operation = 'update';
                    if ( element.id === id ) {
                        if ( payload.value.endsAt )
                            element.endsAt = payload.value.endsAt;
                        if ( payload.value.startsAt )
                            element.startsAt = payload.value.startsAt;
                    }
                });
                // adição do array ao payload para ser enviado no pedido
                actions( 'registerField', { name: 'schedules', value: schedules });
            }
        };

        const addToSchedule = () => {
            const addedSchedules = [];
            addedSchedules.push({
                weekday: payload.value.weekday,
                startsAt: payload.value.startsAt,
                endsAt: payload.value.endsAt,
                operation: 'create'
            });

            actions( 'registerField', { name: 'schedules', value: addedSchedules });
        };

        return {
            ...toRefs( bools ),
            ...toRefs( scheduleInfo ),
            ...toRefs( state ),
            addToPayload,
            addToSchedule,
            closeAddSchedule,
            blockBarAndResetPayload,
            removeSchedule,
            interruptMessageFunction
        };
    }
};
</script>

<style lang="scss">
    .schedule-table {
        &--without-results {
            padding: $card-spacing;
        }
        &__header {
            padding: $card-spacing;
            &__row {
                @include typography-specs( 20px, 26px, 500 );
            }
        }
        &__add-inputs {
            margin-top: 20px;
        }
        &__body {
            max-height: var( --max-height );
            margin-top: 5px;
            overflow-x: auto;
            &__row {
                align-items: center;
                height: 60px;
                padding: $card-spacing;
                gap: 36px;
                &--color {
                    background: $bg-color;
                }
                &__text {
                    @include typography-specs( 18px, 24px, 400 );
                    &__svg {
                        margin-left: 10px;
                    }
                    &__tooltip {
                        @include transform-position( 1px, false, false, -96px, translateX( -50% ) );
                        width: max-content;
                    }
                }
                &__weekday {
                    @include typography-specs( 22px, 29px, 800 );
                    min-width: 46px;
                }
                &__time {
                    @include typography-specs( 18px, 22px, 400 );
                    &--container{
                        gap: 36px;
                    }
                }
            }
        }
        &__modal {
            &__content {
                max-width: 480px;
            }
        }
        &__add__button {
            @include transform-position( -70px, 50px, false, false );
        }
    }

</style>